module.exports = __webpack_public_path__ + "static/media/soya-beans.e4cf9b9a.svg";